import { Grid, Heading } from '@ingeniorforeningen/figurine-core';
import { stripText } from '../../helpers/textsHelpers';
import { trackPromotion } from '../../tracking';
import { Promotion } from '../../types';
import SkeletonPromotionContent from '../Skeleton/SkeletonPromotionContent';
import { Card } from '@ingeniorforeningen/figurine-cms';

type PromotionContentProps = {
  loading: boolean;
  headerText?: string;
  promotions: Promotion[] | null;
  error: string | null;
};

export const PromotionContent = ({
  loading,
  headerText,
  promotions,
  error,
}: PromotionContentProps) => {
  const handleCardClicked = (card: Promotion, index: number) => {
    trackPromotion('/', stripText(card.title), stripText(card.linkUrl), index + 1);
  };

  if (loading || error) {
    return <SkeletonPromotionContent />;
  }

  return (
    <>
      <Grid container mx={0} mb="md" style={{ marginTop: '75px' }}>
        <Grid item sm={7}>
          <Heading type="h1" align="left" mb="sm" text={stripText(headerText)} />
        </Grid>
      </Grid>
      {promotions && (
        <Grid
          container
          mb="xl"
          columns={3}
          style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(21.5625em, 1fr))' }}
        >
          {promotions.map((card, index) => (
            <Card
              key={`${card.title}-${index}`}
              header={stripText(card.title)}
              text={stripText(card.text)}
              image={{ src: stripText(card.imageUrl) }}
              variant="image"
              onClick={() => handleCardClicked(card, index)}
              cta={{
                text: stripText(card.linkText) || 'ok',
                href: stripText(card.linkUrl),
                target: '_blank',
              }}
              fluid
            />
          ))}
        </Grid>
      )}
    </>
  );
};
